import { useRouter } from "vue-router";
import { mapGetters, mapActions } from "vuex";

import { XMarkIcon } from "@heroicons/vue/24/outline";

export default {
	name: "LanguageModal",
	components: {
		XMarkIcon,
	},
	props: ["toggleLanguageModal", "updateLanguages"],
	computed: {
		...mapGetters("languages", ["languages", "activeLanguage"]),
		...mapGetters("staticContent", ["getTranslations"]),
	},
	methods: {
		...mapActions("languages", ["setActiveLanguage"]),
		selectLanguage(language) {
			this.selectedLanguage = language;
		},
		updateLanguage(language) {
			if (language.id === this.activeLanguage.id) {
				return;
			}

			localStorage.setItem("activeLanguage", JSON.stringify(language));

			const currentRoute = this.$router.currentRoute.value;

			const newRoute = {
				...currentRoute,
				params: {
					...currentRoute.params,
					lang: language.two_digit_code,
				},
			};

			this.$router.push(newRoute);

			window.location.reload();
		},
	},
	watch: {
		isVisible: {
			handler(newVal) {
				if (newVal) {
					document.body.classList.add("overflow-hidden", "fixed", "w-full");
					this.scrollY = window.scrollY;
					document.body.style.top = `-${this.scrollY}px`;
				} else {
					document.body.classList.remove("overflow-hidden", "fixed", "w-full");
					document.body.style.top = "";
					if (this.scrollY !== undefined) {
						window.scrollTo(0, this.scrollY);
					}
				}
			},
			immediate: true,
		},
	},
	beforeUnmount() {
		document.body.classList.remove("overflow-hidden", "fixed", "w-full");
		document.body.style.top = "";
	},
	setup() {
		const router = useRouter();
		return { router };
	},
};
